import React from 'react';
import { Link } from 'react-router-dom';
import { FaLock } from 'react-icons/fa';

import './unautherized.scss';


function Unautherized() {
  return (
    <div className='Unautherized'>
      <div className='Unautherized_card' dir='rtl'>
        <span className='Unautherized_icon'><FaLock /></span>
        <span className='Unautherized_code'>401</span>
        <span className='Unautherized_title'>ليس لديك الصلاحية اللازمة</span>
        <span className='Unautherized_desc'>لا تملك صلاحية الوصول إلى هذه الصفحة.</span>
        <Link className='Unautherized_btn' to='/emp'>العودة للصفحة الرئيسية</Link>
      </div>
    </div>
  );
}

export default Unautherized;
